import Vue from 'vue'
import Router from 'vue-router'
import Intro from './views/Intro.vue'

Vue.use(Router)



export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'intro',
      component: Intro,
      meta: {rank: 0}
    },
    {
      path: '/section1',
      name: 'section1',
      meta: { rank: 1},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Section1" */ './views/Section1.vue')
    },
    {
      path: '/section2',
      name: 'section2',
      meta: { rank: 2 },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Section2" */ './views/Section2.vue')
    },
    {
      path: '/section3',
      name: 'section3',
      meta: { rank: 3},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Section3" */ './views/Section3.vue')
    },
    {
      path: '/answer',
      name: 'answer',
      meta: { rank: 4},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Answer" */ './views/Answer.vue')
    },
    {
      path: '/thankyou',
      name: 'thankyou',
      meta: { rank: 5},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Thankyou" */ './views/Thankyou.vue')
    }
  ]
})

